var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},[_c('FixedIcon',{staticStyle:{"z-index":"3"}}),_c('banner'),_c('JTMessage'),_c('DotInformation'),_c('SpecialSubject'),_c('BottomField')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }